<template>
  <router-view />
</template>

<script>
export default {
  name: 'TransferPricingIndex',
}
</script>
